import { Component, ChangeDetectionStrategy, Input, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent, TooltipDirective } from '@mode/capra';
import { SelectWithSearchComponent } from '@mode/shared/ui';
import { MatLegacySelectModule } from '@angular/material/legacy-select';
import { DefaultOptions, ParamChanged, Parameters, ScheduleParam } from './parameter-types';

@Component({
  standalone: true,
  imports: [CommonModule, IconComponent, TooltipDirective, SelectWithSearchComponent, MatLegacySelectModule],
  selector: 'mode-parameters',
  templateUrl: './parameters.component.html',
  styleUrls: ['./parameters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ParametersComponent {
  @Input() defaultOptions: DefaultOptions = { class: { isSelected: false, label: '', value: '' } };
  @Input() params: Parameters = {
    class: { default: '', human_name: '', name: '', options: [], options_error: null, type: '', value: '' },
  };
  @Input() scheduleParams: ScheduleParam = { class: [] };
  @Output() paramChanged = new EventEmitter<ParamChanged>();
  @Output() multiSelectParameterChanged = new EventEmitter<ParamChanged>();

  onParamChange(name: string, event: { value: unknown; target: { value: unknown } }): void {
    const value = event.value ?? event.target.value;
    this.paramChanged.emit({ name, value: value ?? null });
  }
}
